export const USER_AUTHENTICATED = "USER_AUTHENTICATED";
export const USER_UNAUTHENTICATED = "USER_UNAUTHENTICATED";
export const USER_AUTHORIZED = "USER_AUTHORIZED";
export const USER_UNAUTHORIZED = "USER_UNAUTHORIZED";